<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="rank-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <!-- 顶部搜索栏（折叠版） -->
        <div class="search-bar">
          <!-- 折叠/展开按钮 -->
          <el-button
            icon="el-icon-arrow-down"
            type="text"
            @click="toggleSearch"
            style="margin-right: 10px"
          >
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </el-button>


          <!-- 搜索项 -->
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              alignItems: 'center',
              gap: '10px',
              flexWrap: 'wrap',
            }"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="请输入用户ID"
              clearable
              style="width: 180px"
            ></el-input>

            <el-select v-model="searchParams.type" placeholder="PK类型" clearable style="width:140px">
              <el-option label="欧皇" :value="1"></el-option>
              <el-option label="小丑" :value="2"></el-option>
            </el-select>

            <el-select v-model="searchParams.status" placeholder="房间状态" clearable style="width:140px">
              <el-option label="未开始" :value="0"></el-option>
              <el-option label="已结束" :value="1"></el-option>
            </el-select>

            <el-select v-model="searchParams.win_status" placeholder="对战结果" clearable style="width:140px">
              <el-option label="平局" :value="0"></el-option>
              <el-option label="失败" :value="1"></el-option>
              <el-option label="胜利" :value="2"></el-option>
            </el-select>
          </div>


          <!-- 搜索/重置/列筛选 -->
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="getRecordList"
            >
              搜索
            </el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">
              重置
            </el-button>
            <el-popover
              placement="bottom"
              title="显示列筛选"
              trigger="click"
              width="260"
            >
              <el-checkbox-group v-model="checkedColumns">
                <el-checkbox
                  v-for="item in columnOptions"
                  :key="item.prop"
                  :label="item.prop"
                >{{ item.label }}</el-checkbox>
              </el-checkbox-group>
              <div style="text-align: right; margin-top: 8px">
                <el-button size="mini" @click="handleCheckAll">全选</el-button>
                <el-button size="mini" @click="handleClearAll">清空</el-button>
              </div>
              <el-button slot="reference" icon="el-icon-s-tools" type="info"
                >列筛选</el-button
              >
            </el-popover>
          </div>
        </div>


        <el-table
          height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column
            label="ID"
            prop="id"
            width="70"
            align="center"
            v-if="checkedColumns.includes('id')"
          />
          <el-table-column
            label="头像"
            width="80"
            align="center"
            v-if="checkedColumns.includes('avatar')"
          >
            <template slot-scope="scope">
              <el-avatar :src="scope.row.avatar" size="40"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="100"
            align="center"
            v-if="checkedColumns.includes('user_id')"
          />
          <el-table-column
            label="用户编号"
            prop="user_no"
            min-width="160"
            v-if="checkedColumns.includes('user_no')"
          />
          <el-table-column
            label="昵称"
            prop="nickname"
            min-width="140"
            v-if="checkedColumns.includes('nickname')"
          />
          <el-table-column
            label="PK类型"
            width="90"
            align="center"
            v-if="checkedColumns.includes('type')"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.type === 1 ? 'success' : 'warning'">
                {{ scope.row.type === 1 ? '欧皇' : '小丑' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="房间状态"
            width="100"
            align="center"
            v-if="checkedColumns.includes('status')"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 1 ? 'info' : 'default'">
                {{ scope.row.status === 1 ? '已结束' : '未开始' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="对战结果"
            width="100"
            align="center"
            v-if="checkedColumns.includes('win_status')"
          >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.win_status === 2 ? 'success' : scope.row.win_status === 1 ? 'danger' : ''"
              >
                {{ scope.row.win_status === 2 ? '胜利' : scope.row.win_status === 1 ? '失败' : '平局' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="局数"
            prop="num"
            width="80"
            align="center"
            v-if="checkedColumns.includes('num')"
          />
          <el-table-column
            label="实付金额"
            prop="total_pay"
            width="110"
            align="center"
            v-if="checkedColumns.includes('total_pay')"
          >
            <template slot-scope="scope">¥{{ scope.row.total_pay }}</template>
          </el-table-column>
          <el-table-column
            label="回收金额"
            prop="recovery_price"
            width="110"
            align="center"
            v-if="checkedColumns.includes('recovery_price')"
          >
            <template slot-scope="scope">¥{{ scope.row.recovery_price }}</template>
          </el-table-column>
          <el-table-column
            label="PK时间"
            prop="pk_at"
            min-width="170"
            align="center"
            v-if="checkedColumns.includes('pk_at')"
          />
          <el-table-column
            label="创建时间"
            prop="created_at"
            min-width="170"
            align="center"
            v-if="checkedColumns.includes('created_at')"
          />
        </el-table>


        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>
      </div>
    </div>


    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-rank-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- 搜索 -->
        <div class="mobile-search-group">
          <el-button
            type="text"
            icon="el-icon-arrow-down"
            @click="toggleSearch"
            style="width: 100%; text-align: left; padding-left: 0"
          >
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </el-button>
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              clearable
              size="medium"
            />
            <el-select v-model="searchParams.type" placeholder="PK类型" clearable size="medium">
              <el-option label="欧皇" :value="1"></el-option>
              <el-option label="小丑" :value="2"></el-option>
            </el-select>
            <el-select v-model="searchParams.status" placeholder="房间状态" clearable size="medium">
              <el-option label="未开始" :value="0"></el-option>
              <el-option label="已结束" :value="1"></el-option>
            </el-select>
            <el-select v-model="searchParams.win_status" placeholder="对战结果" clearable size="medium">
              <el-option label="平局" :value="0"></el-option>
              <el-option label="失败" :value="1"></el-option>
              <el-option label="胜利" :value="2"></el-option>
            </el-select>
          </div>
        </div>
        <div style="display: flex; gap: 8px; margin-bottom: 10px">
          <el-button
            type="primary"
            plain
            round
            @click="getRecordList"
            style="flex: 1"
          >搜索</el-button>
          <el-button plain round @click="resetSearch" style="flex: 1">重置</el-button>
        </div>


        <!-- 卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
          >
            <div class="card-header">
              <div style="display: flex; align-items: center; gap: 10px">
                <el-avatar :src="item.avatar" size="50"></el-avatar>
                <div class="info">
                  <div class="nickname">{{ item.nickname || "未知用户" }}</div>
                  <div class="uid">ID: {{ item.user_id }}｜编号: {{ item.user_no }}</div>
                </div>
              </div>
              <div class="tag-group">
                <span class="tag pk-type" :class="item.type === 1 ? 'tag-eu' : 'tag-clown'">
                  {{ item.type === 1 ? '欧皇' : '小丑' }}
                </span>
                <span class="tag status-tag" :class="item.status === 1 ? 'tag-end' : 'tag-wait'">
                  {{ item.status === 1 ? '已结束' : '未开始' }}
                </span>
                <span class="tag res-tag" :class="item.win_status === 2 ? 'tag-win' : item.win_status === 1 ? 'tag-lose' : 'tag-draw'">
                  {{ item.win_status === 2 ? '胜利' : item.win_status === 1 ? '失败' : '平局' }}
                </span>
              </div>
            </div>
            <div class="card-body">
              <div class="row-item">局数：{{ item.num }} 局</div>
              <div class="row-item">实付：¥{{ item.total_pay }}</div>
              <div class="row-item">回收：¥{{ item.recovery_price }}</div>
              <div class="row-item time">PK时间：{{ item.pk_at }}</div>
            </div>
          </div>
        </div>


        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            layout="total, prev, pager, next"
            :total="pageInfo.total"
            pager-count="2"
            small
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import api from "../../api/api.js";
export default {
  name: "PkRoomRecord",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },


      // 搜索参数
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
        type: null,
        status: null,
        win_status: null,
      },


      // 表格列配置
      columnOptions: [
        { label: "ID", prop: "id" },
        { label: "头像", prop: "avatar" },
        { label: "用户ID", prop: "user_id" },
        { label: "用户编号", prop: "user_no" },
        { label: "昵称", prop: "nickname" },
        { label: "PK类型", prop: "type" },
        { label: "房间状态", prop: "status" },
        { label: "对战结果", prop: "win_status" },
        { label: "局数", prop: "num" },
        { label: "实付金额", prop: "total_pay" },
        { label: "回收金额", prop: "recovery_price" },
        { label: "PK时间", prop: "pk_at" },
        { label: "创建时间", prop: "created_at" },
      ],
      checkedColumns: [
        "id",
        "avatar",
        "user_id",
        "user_no",
        "nickname",
        "type",
        "status",
        "win_status",
        "num",
        "total_pay",
        "recovery_price",
        "pk_at",
        "created_at",
      ],


      searchCollapsed: true,
    };
  },
  created() {
    this.getRecordList();
  },
  methods: {
    // 获取PK房间记录
    async getRecordList() {
      this.loading = true;
      try {
        const res = await api.loss.pkRoomRecord({
          params: this.searchParams,
        });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data || [];
          this.pageInfo.total = res.data.data.total || 0;
        }
      } finally {
        this.loading = false;
      }
    },


    // 重置搜索
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
        type: null,
        status: null,
        win_status: null,
      };
      this.getRecordList();
    },


    // 每页条数切换
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.searchParams.page = 1;
      this.getRecordList();
    },
    // 页码切换
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getRecordList();
    },


    // 列筛选全选/清空
    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((i) => i.prop);
    },
    handleClearAll() {
      this.checkedColumns = [];
    },


    // 折叠搜索栏
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
  },
};
</script>


<style scoped>
/* PC样式 */
.rank-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}


/* 移动端基础 */
.mobile-rank-container {
  padding: 12px;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}
.info .nickname {
  font-size: 16px;
  font-weight: 500;
}
.info .uid {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.tag-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.tag {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  color: #fff;
}
.tag-eu {
  background: #67c23a;
}
.tag-clown {
  background: #e6a23c;
}
.tag-end {
  background: #909399;
}
.tag-wait {
  background: #c0c4cc;
  color: #333 !important;
}
.tag-win {
  background: #67c23a;
}
.tag-lose {
  background: #f56c6c;
}
.tag-draw {
  background: #409eff;
}
.card-body {
  font-size: 13px;
  color: #666;
}
.row-item {
  line-height: 1.8;
}
.row-item.time {
  margin-top: 6px;
  color: #999;
  font-size: 12px;
}
</style>


<style>
@media (max-width: 768px) {
  .pc-version {
    display: none !important;
  }
  .mobile-version {
    display: block !important;
  }
}
@media (min-width: 769px) {
  .pc-version {
    display: block !important;
  }
  .mobile-version {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/loss/pkroomrecord.vue